import { OrderStatusEnum } from '@/api-sdk';
import { SelectOption } from '@/types';

export const dataPrintProofStatus: SelectOption[] = [
  {
    value: 'all',
    text: 'labels.all',
  },
  {
    value: OrderStatusEnum.fulfilled,
    text: 'content.printProof.statusOrderFulfilled',
  },
  {
    value: OrderStatusEnum.pending,
    text: 'content.printProof.statusOrderPending',
  },
  {
    value: OrderStatusEnum.print_proof_review,
    text: 'content.printProof.statusOrderReview',
  },
];
